import(/* webpackMode: "eager" */ "/home/rajat/Downloads/HR Shakti/frontend/src/app/(public)/blogs/page.tsx");
